export default __webpack_public_path__ + "static/media/event-time.97ed6e50.svg";